import React from 'react'
import titlesData from '../../titles.json';

function Index() {

    const storedLanguage = localStorage.getItem('language');

    return (
        <>
            {/* Page Content Open   */}
            <div className="container-fluid py-3 px-3">
                <div className="card mb-3">
                    <div className="card-body">
                        <h4 className="page_heading">{storedLanguage === 'hi' ? titlesData.hi.Faq_Details : titlesData.en.Faq_Details}</h4>
                        <div className="row align-items-center">
                            {storedLanguage === 'hi' ? (
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                {storedLanguage === 'hi'
                                                    ? <div dangerouslySetInnerHTML={{ __html: titlesData.hi.FAQ_QUESTION_1 }} />
                                                    : <div dangerouslySetInnerHTML={{ __html: titlesData.en.FAQ_QUESTION_1 }} />
                                                }
                                            </button>



                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne"
                                            data-bs-parent="#accordionExample">
                                            <div className="accordion-body">

                                                {storedLanguage === 'hi'
                                                    ? <div dangerouslySetInnerHTML={{ __html: titlesData.hi.FAQ_ANWSER_1 }} />
                                                    : <div dangerouslySetInnerHTML={{ __html: titlesData.en.FAQ_ANWSER_1 }} />
                                                }




                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">

                                                {storedLanguage === 'hi'
                                                    ? <div dangerouslySetInnerHTML={{ __html: titlesData.hi.FAQ_QUESTION_2 }} />
                                                    : <div dangerouslySetInnerHTML={{ __html: titlesData.en.FAQ_QUESTION_2 }} />
                                                }



                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionExample">
                                            <div className="accordion-body">

                                                {storedLanguage === 'hi'
                                                    ? <div dangerouslySetInnerHTML={{ __html: titlesData.hi.FAQ_ANWSER_2 }} />
                                                    : <div dangerouslySetInnerHTML={{ __html: titlesData.en.FAQ_ANWSER_2 }} />
                                                }




                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="accordion" id="accordionExample">
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingOne">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                Ques 1 : What is IIP?
                                            </button>
                                        </h2>
                                        <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne"
                                            data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <strong>Answer : </strong>
                                                <p>The IIP Module will be used for capturing the data online for the Manufacturing
                                                    sectors, Electrical Sectors and Mining Sectors.</p>
                                                <p>IIP module also will be used for capturing Agriculture Production values and
                                                    Agricultural Production volume.</p>
                                                <p>This module will be a part of " Modernization of Statistical Information System" to
                                                    be developed at DES Lucknow(U.P.).</p>
                                                <p>The IIP Module will have interactions with specific modules, tools and the master
                                                    databases like District Master,Town/Village Master etc.</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="headingTwo">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                Ques 2: What do you mean by user levels?
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                            data-bs-parent="#accordionExample">
                                            <div className="accordion-body">
                                                <strong>Answer: </strong>
                                                <p>No</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}





                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Index